<template>
  <b-modal
    id="reAssign-job"
    centered
    hide-footer
    hide-header
    :visible="showReassignModal"
    no-close-on-backdrop
    @hidden="$emit('handle-close')"
  >
    <main>
      <header>
        <div
          class="d-flex align-items-center justify-content-between px-4 py-3"
        >
          <div class="b-modal-header">
            {{ jobName ? "Trigger CVS" : "Reassign" }}
          </div>
          <div class="rotate-on-hover" @click="$emit('handle-close')">
            <img
              src="../../../assets/panelist/blue_cross.svg"
              alt=""
              class="pointer rotate-on-hover"
            />
          </div>
        </div>
      </header>
      <hr class="m-0" />
      <body>
        <section class="py-3 px-4">
          <section v-if="!jobName">
            <div class="reassign-head">Recruiter Details</div>
            <div class="mt-2 common-blue-card">
              <b-card>
                <b-row class="align-items-center">
                  <b-col cols="7" class="reassign-head-subead text-truncate">
                    {{ reassignedDetails.recruiterInfo.username }}
                  </b-col>
                  <b-col
                    cols="5"
                    class="pl-0 reassign-head-mail text-truncate"
                    style="text-align: -webkit-right"
                    v-b-popover.hover.top="
                      reassignedDetails.recruiterInfo.email
                    "
                  >
                    {{ reassignedDetails.recruiterInfo.email }}
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </section>
          <hr v-if="!jobName" />
          <section
            class="reassign-main-container p-3"
            :style="jobName && 'height: calc(100vh - 305px) !important;'"
          >
            <section
              class="
                reassign-main-container-head
                w-100
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div>Candidate Details</div>
              <div>Total Candidate(s): {{ totalCandidates }}</div>
            </section>
            <section class="mt-3">
              <div class="accordion common-accordian-card" role="tablist">
                <section
                  class="common-red-accordian-card"
                  v-if="reassignedDetails.alreadyExisting.length"
                >
                  <b-card no-body class="mb-1 px-2 py-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <section
                        @click="toggleAccordion('exists')"
                        v-b-toggle.accordion-1
                        class="
                          w-100
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <section>
                          <div class="reassign-main-container-head">
                            {{
                              jobName ? "Notification sent" : "Already Existing"
                            }}
                          </div>
                          <div class="reassign-main-container-subhead">
                            {{
                              jobName
                                ? `for ${formattedUsername(jobName)} job`
                                : `in ${reassignedDetails.recruiterInfo.username} talentpool`
                            }}
                          </div>
                        </section>
                        <section class="d-flex align-items-center">
                          <div class="reassign-main-container-circle">
                            {{ reassignedDetails.alreadyExisting.length }}
                          </div>
                          <div class="mx-2">
                            <img src="../../../assets/img/line.svg" alt="" />
                          </div>
                          <div>
                            <img
                              v-if="isExists"
                              src="../../../assets/img/new-reassign-downArrow.svg"
                              class="pointer"
                              alt=""
                            />
                            <img
                              v-else
                              class="pointer"
                              src="../../../assets/img/new-reassign-upArrow.svg"
                              alt=""
                            />
                          </div>
                        </section>
                      </section>
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="p-0 pr-1">
                        <div
                          class="common-white-card my-2"
                          v-for="(
                            cand, index
                          ) in reassignedDetails.alreadyExisting"
                          :key="index"
                        >
                          <b-card>
                            <section
                              class="
                                d-flex
                                align-items-center
                                justify-content-between
                                w-100
                              "
                            >
                              <section
                                class="reassign-head-subead w-60 text-truncate"
                              >
                                <span
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                >
                                  {{ formattedUsername(cand.name) }}
                                </span>
                              </section>
                              <section
                                class="
                                  reassign-head-mail
                                  w-40
                                  text-truncate text-right
                                "
                              >
                                <span
                                  v-b-tooltip.hover.bottom="cand.email"
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                >
                                  {{ cand.email }}
                                </span>
                              </section>
                            </section>
                          </b-card>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </section>
                <section
                  class="common-green-accordian-card mt-3"
                  v-if="reassignedDetails.newlyAdded.length"
                >
                  <b-card no-body class="mb-1 px-2 py-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <section
                        @click="toggleAccordion('newlyAdded')"
                        v-b-toggle.accordion-2
                        class="
                          w-100
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <section>
                          <div class="reassign-main-container-head">
                            Newly Added
                          </div>
                          <div class="reassign-main-container-subhead">
                            {{
                              jobName
                                ? `for ${formattedUsername(jobName)} job`
                                : `in ${reassignedDetails.recruiterInfo.username} talentpool`
                            }}
                          </div>
                        </section>
                        <section class="d-flex align-items-center">
                          <div class="reassign-main-container-circle">
                            {{ reassignedDetails.newlyAdded.length }}
                          </div>
                          <div class="mx-2">
                            <img src="../../../assets/img/line.svg" alt="" />
                          </div>
                          <div>
                            <img
                              v-if="isNew"
                              src="../../../assets/img/accessconnew/blueDownArrow.svg"
                              alt=""
                              class="pointer"
                            />
                            <img
                              v-else
                              class="pointer"
                              src="../../../assets/talentpool/blueuparrow.svg"
                              alt=""
                            />
                          </div>
                        </section>
                      </section>
                    </b-card-header>
                    <b-collapse
                      id="accordion-2"
                      visible
                      accordion="my-accordion1"
                      role="tabpanel"
                    >
                      <b-card-body class="p-0 pr-1">
                        <div
                          class="common-white-card my-2"
                          v-for="(cand, index) in reassignedDetails.newlyAdded"
                          :key="index"
                        >
                          <b-card>
                            <section
                              class="
                                d-flex
                                align-items-center
                                justify-content-between
                                w-100
                              "
                            >
                              <section
                                class="reassign-head-subead text-truncate w-60"
                              >
                                <span
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                >
                                  {{ formattedUsername(cand.name) }}
                                </span>
                              </section>
                              <section
                                class="reassign-head-mail w-40 text-truncate"
                              >
                                <span
                                  v-b-tooltip.hover.bottom="cand.email"
                                  style="min-width: auto; max-width: 90%"
                                  class="
                                    d-inline-block
                                    text-truncate text-right
                                  "
                                >
                                  {{ cand.email }}
                                </span>
                              </section>
                            </section>
                          </b-card>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </section>
              </div>
            </section>
          </section>
        </section>
      </body>
      <hr class="m-0" />
      <footer class="p-3">
        <section class="w-100 bluebtn" style="text-align: -webkit-right">
          <b-button
            class="acs-addBtn-modal pl-4 pr-4"
            @click="$emit('handle-close')"
            >Okay</b-button
          >
        </section>
      </footer>
    </main>
  </b-modal>
</template>

<script>
export default {
  name: "ReassignModal",
  props: {
    reassignedDetails: Object,
    showReassignModal: Boolean,
    jobName: String,
  },
  data() {
    return {
      isExists: false,
      isNew: false,
    };
  },
  computed: {
    totalCandidates() {
      return (
        (this.reassignedDetails?.alreadyExisting?.length || 0) +
        (this.reassignedDetails?.newlyAdded?.length || 0)
      );
    },
  },
  methods: {
    formattedUsername(username) {
      return username.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    toggleAccordion(val) {
      if (val == "exists") {
        this.isExists = !this.isExists;
      } else if (val == "newlyAdded") {
        this.isNew = !this.isNew;
      }
    },
  },
};
</script>

<style scoped>
.reassign-head {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.reassign-head-subead {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.reassign-head-mail {
  font-family: "Lato";
  font-weight: 400;
  font-size: 12px;
  color: #666666;
}

.reassign-main-container {
  background: #f6f9fb;
  border-radius: 6px;
  height: calc(100vh - 450px);
  overflow: auto;
}

.reassign-main-container-head {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
}

.reassign-main-container-subhead {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 11px;
  color: #666666;
}

.reassign-main-container-circle {
  width: 20px;
  height: 20px;
  border: 1px solid #8c8c8c;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #8c8c8c;
  border-radius: 50%;
  text-align: center;
}

/* accordian classes */
.common-accordian-card .card-header {
  background: transparent;
  border-bottom: unset;
}

/* .common-accordian-card .card-body {
  min-height: auto;
  max-height: 287px;
  overflow-y: auto;
  overflow-x: hidden;
} */

.common-accordian-card .common-red-accordian-card > .card {
  border: 2px solid #e70016;
  background: #f6f9fb;
}

.common-accordian-card .common-green-accordian-card > .card {
  border: 2px solid #038e00;
  background: #f6f9fb;
}
</style>
